// --------------------------------------------------------------------------
// Entry point of application.
// Performs rendering and inserts components in HTML DOM.
// Is the bridge between the components in App.tsx file & the web browser.
// --------------------------------------------------------------------------

import { ChakraProvider } from '@chakra-ui/react'
import theme from "./theme";
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ChakraProvider theme={theme}>
    <App />
  </ChakraProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
